
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"23","viewBox":"0 0 36 23","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.59 23c6.178 0 11.188-5.149 11.188-11.5S30.768 0 24.589 0 13.401 5.149 13.401 11.5 18.41 23 24.589 23z","fill":"#3084B9"}}),_c('path',{attrs:{"d":"M11.188 0c-1.47-.004-2.927.29-4.286.867a11.141 11.141 0 00-3.634 2.492A11.494 11.494 0 00.843 7.094 11.746 11.746 0 000 11.5V23h11.188c2.968 0 5.814-1.212 7.912-3.368 2.098-2.157 3.277-5.082 3.277-8.132S21.198 5.525 19.1 3.37C17.002 1.212 14.156 0 11.188 0z","fill":"#F9B621"}}),_c('path',{attrs:{"opacity":".15","d":"M24.59 23c6.178 0 11.188-5.149 11.188-11.5S30.768 0 24.589 0 13.401 5.149 13.401 11.5 18.41 23 24.589 23z","fill":"#3084B9"}})])
          )
        }
      }
    